import { getStyleDeclaration } from './get-style-declaration.js';
import { widgetSelector } from './helpers';

/**
 * Transform chart widget description into list of style declarations.
 *
 * @example
 * {
 *   "id": "chartWidget_104802",
 *   "type": "chart",
 *   "x": 389,
 *   "y": 203,
 *   "width": 163,
 *   "height": 163,
 *   "_isModified": false
 * }
 * @param widgetDescription
 */

export function chartWidget(widgetDescription) {
  const { placements = [] } = widgetDescription;
  const selector = widgetSelector(widgetDescription);
  const rules = [
    ...placements.map(getStyleDeclaration.positions(selector)),
    ...placements.map(getStyleDeclaration.size(selector)),
  ];

  return rules;
}
